export default __webpack_public_path__ + "static/facebook-5a4948c42ae123138dfa60b1598a50c0.png";